import * as React from 'react';

import { Messages } from '../../../codegen/Localize';
import { DetailsTooltipStyles } from '../CardView/DetailsTooltipStyles';
import { MarkupField } from './Elements/MarkupField';
import { Name } from './Elements/Name';
import { Tooltip } from './Elements/Tooltip';
import { UpdatedAt } from './Elements/UpdatedAt';
import { User } from './Elements/User';
import { ContentTooltipProps, TooltipDescriptionTestId } from './TooltipHelper';


export function DataRoleTooltip(props: ContentTooltipProps): JSX.Element {
  const { content, urls } = props;
  return (
    <Tooltip>
      <Name name={content.name} />
      <MarkupField markup={props.content.description}
                  testId={TooltipDescriptionTestId}
                  extraClasses={[DetailsTooltipStyles.MetadataSectionWithContentDescription]} />
      <User user={props.content.owner} label={Messages.owner()} urls={urls} />
      <UpdatedAt value={props.content.updatedAt} />
    </Tooltip>
  );
}
